// src/components/SideFilter.tsx
import React, { useState } from 'react';

interface SideFilterProps {
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    onFilterChange?: (filters: any) => void; // Hacemos opcional
  }

export default function SideFilter({ show, setShow, onFilterChange }: SideFilterProps) {
  const [searchText, setSearchText] = useState<string>('');
  const [tipo, setTipo] = useState<string>('');
  const [zona, setZona] = useState<string>('');
  const [recamaras, setRecamaras] = useState<string>('');
  const [precioMin, setPrecioMin] = useState<string>('');
  const [precioMax, setPrecioMax] = useState<string>('');
  const [currency, setCurrency] = useState<string>('USD');

  const MLS_ZONAS = [
    'Hotel Zone', 'Nuevo Vallarta West', 'Bucerias', 'Marina',
    'La Cruz de Huanacaxtle', 'Centro North', 'Francisco Villa West',
    'Aramara', 'Airport', 'Centro South', 'San Pancho', 'Flamingos',
    'Francisco Villa East', 'South Shore', 'Mezcales', 'Sayulita',
    'Nuevo Vallarta East'
  ];

  const handleApplyFilters = () => {
    const filters: any = {};
    if (searchText) filters.searchText = searchText;
    if (tipo) filters.propertyType = tipo;
    if (zona) filters.zona = zona;
    if (recamaras) filters.recamaras = recamaras;
    if (precioMin) filters.priceMin = precioMin;
    if (precioMax) filters.priceMax = precioMax;
    filters.currency = currency;

    onFilterChange && onFilterChange(filters); // Evita errores si no se pasa
  };

  return (
    <div className={`simple-sidebar sm-sidebar ${show ? 'd-block' : ''}`} style={{ left: '0' }}>
      <div className="search-sidebar_header">
        <h4 className="ssh_heading">Cerrar Filtros</h4>
        <button className="btn-close" onClick={() => setShow(false)} aria-label="Cerrar panel de filtros" type="button"><i className="fa-regular fa-circle-xmark fs-5 text-muted-2" aria-hidden="true"></i></button>
      </div>

      <div className="sidebar-widgets">
        <div className="search-inner p-0">

          {/* Búsqueda por texto */}
          <div className="single_search_boxed">
            <h5>Buscar</h5>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre, ubicación, tipo..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {/* Tipo de Propiedad */}
          <div className="single_search_boxed mt-3">
            <h5>Tipo de Propiedad</h5>
            <select className="form-select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="">Todos</option>
              <option value="departamento">Departamento</option>
              <option value="casa">Casa</option>
              <option value="penthouse">Penthouse</option>
              <option value="terreno">Terreno</option>
              <option value="local">Local Comercial</option>
              <option value="edificio">Edificio</option>
              <option value="negocio">Negocio</option>
            </select>
          </div>

          {/* Zona */}
          <div className="single_search_boxed mt-3">
            <h5>Zona</h5>
            <select className="form-select" value={zona} onChange={(e) => setZona(e.target.value)}>
              <option value="">Todas las zonas</option>
              {MLS_ZONAS.map(z => (
                <option key={z} value={z}>{z}</option>
              ))}
            </select>
          </div>

          {/* Recámaras */}
          <div className="single_search_boxed mt-3">
            <h5>Recámaras</h5>
            <select className="form-select" value={recamaras} onChange={(e) => setRecamaras(e.target.value)}>
              <option value="">Cualquiera</option>
              <option value="1">1 Recámara</option>
              <option value="2">2 Recámaras</option>
              <option value="3">3 Recámaras</option>
              <option value="4">4 Recámaras</option>
              <option value="5">5 Recámaras o más</option>
            </select>
          </div>

          {/* Rango de Precios */}
          <div className="single_search_boxed mt-3">
            <h5>Precio</h5>
            <div className="mb-2">
              <select className="form-select" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                <option value="USD">USD (Dólares)</option>
                <option value="MXN">MXN (Pesos)</option>
              </select>
            </div>
            <div className="d-flex gap-2">
              <input
                type="number"
                placeholder="Mín"
                className="form-control"
                value={precioMin}
                onChange={(e) => setPrecioMin(e.target.value)}
              />
              <input
                type="number"
                placeholder="Máx"
                className="form-control"
                value={precioMax}
                onChange={(e) => setPrecioMax(e.target.value)}
              />
            </div>
          </div>

          {/* Botón Aplicar Filtros */}
          <div className="single_search_boxed mt-4">
            <button
              className="btn btn-primary w-100"
              onClick={handleApplyFilters}
            >
              <i className="fa fa-filter me-2"></i>
              Aplicar Filtros
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
